import classNames from "classnames";
import React from "react";

import ACButton from "ac-components/ac-button/ACButton";
import FilterIcon from "ac-components/ac-icons/FilterIcon";

import "./ACFilterableCell.less";

interface ACFilterableCellProps {
  applyCellFilter?: () => void;
  children: React.ReactNode;
  isAQLApplied?: boolean;
}
const ACFilterableCell: React.FC<ACFilterableCellProps> = ({
  applyCellFilter,
  children,
  isAQLApplied,
}) => {
  return (
    <div className={classNames(`ac-filterable-cell-container`, {})}>
      <div className="ac-filterable-cell-and-filter">
        <div className="ac-filterable-cell-component">{children}</div>
        {!isAQLApplied && applyCellFilter && (
          <ACButton
            className="ac-filter-icon-button"
            style={{ marginLeft: 2 }}
            type="ghost"
            iconOnly
            size="sm"
            onClick={applyCellFilter}
          >
            <FilterIcon />
          </ACButton>
        )}
      </div>
    </div>
  );
};
export default ACFilterableCell;
